/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiAnalyticEventWorkflowAssociatedFromJSON(json) {
    return StreemApiAnalyticEventWorkflowAssociatedFromJSONTyped(json, false);
}
export function StreemApiAnalyticEventWorkflowAssociatedFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'workflowSid': !exists(json, 'workflow_sid') ? undefined : json['workflow_sid'],
        'associationSid': !exists(json, 'association_sid') ? undefined : json['association_sid'],
        'associationType': !exists(json, 'association_type') ? undefined : json['association_type'],
    };
}
export function StreemApiAnalyticEventWorkflowAssociatedToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'workflow_sid': value.workflowSid,
        'association_sid': value.associationSid,
        'association_type': value.associationType,
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiAnalyticEventWorkflowAssociatedAssociationType;
(function (StreemApiAnalyticEventWorkflowAssociatedAssociationType) {
    StreemApiAnalyticEventWorkflowAssociatedAssociationType["INVITE"] = "ASSOCIATION_TYPE_INVITE";
    StreemApiAnalyticEventWorkflowAssociatedAssociationType["ROOM"] = "ASSOCIATION_TYPE_ROOM";
    StreemApiAnalyticEventWorkflowAssociatedAssociationType["INVALID"] = "ASSOCIATION_TYPE_INVALID";
})(StreemApiAnalyticEventWorkflowAssociatedAssociationType || (StreemApiAnalyticEventWorkflowAssociatedAssociationType = {}));
//# sourceMappingURL=StreemApiAnalyticEventWorkflowAssociated.js.map